import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { comboboxCollection } from './utils.js';
import { useComboboxContext } from './useComboboxContext.js';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';
import '../Collection/Collection.js';
import '../../utils/mergeRefs.js';
import '@indeed/ifl-css';

/**
 * ComboboxMenuList
 *
 * Contains the `ComboboxMenuItem` elements and sets up the proper ARIA
 * attributes for the list.
 *
 * @deprecated The `Combobox` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const ComboboxMenuList = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children,
    sx,
    ...menuProps
  } = props;
  const {
    getMenuProps
  } = useComboboxContext();
  const {
    CollectionContainer
  } = comboboxCollection;
  return jsx(CollectionContainer, null, jsx(Box, _extends({
    as: "ul",
    sx: {
      alignSelf: "stretch",
      paddingBlockStart: 0,
      paddingBlockEnd: 0,
      paddingInlineStart: 0,
      paddingInlineEnd: 0,
      flex: "1 1 auto",
      overflow: "auto",
      zIndex: 1,
      ...sx
    }
  }, getMenuProps({
    ref: forwardedRef,
    onMouseLeave: event => {
      /**
       * Hook into Downshift's default onMouseLeave event.
       *
       * No longer using mouse events to set the "higlighted" option,
       * thus no need to clear. See ComboboxMenuItem for more info.
       */

      // @ts-ignore
      event.nativeEvent.preventDownshiftDefault = true;
    },
    ...menuProps
  })), children));
});
ComboboxMenuList.displayName = "ComboboxMenuList";

export { ComboboxMenuList };
